document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const button = form?.querySelector('[data-add-button]');
  const price = form?.closest('[data-product-panel]')?.querySelector('[data-product-price]');
  const compare = form?.closest('[data-product-panel]')?.querySelector('[data-product-compare]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (compare) {
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
  }
});

const closeMobileSearch = (details) => {
  if (!details) return;
  details.open = false;
  document.body.classList.remove('dt-search-open');
};

document.querySelectorAll('[data-mobile-search]').forEach((details) => {
  details.addEventListener('toggle', () => {
    document.body.classList.toggle('dt-search-open', details.open);
    if (details.open) {
      document.querySelectorAll('.dt-mobile-nav[open]').forEach((nav) => {
        nav.open = false;
      });
      window.setTimeout(() => details.querySelector('[data-search-input]')?.focus(), 40);
    }
  });
});

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-search-close]');
  if (closeButton) {
    closeMobileSearch(closeButton.closest('[data-mobile-search]'));
    return;
  }

  if (event.target.matches('[data-search-overlay]')) {
    closeMobileSearch(event.target.closest('[data-mobile-search]'));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-mobile-search][open]').forEach((details) => closeMobileSearch(details));
});
